'use client';

import { useState } from 'react';
import styles from './TableOfContents.module.css';

interface TocItem {
  id: string;
  heading: string;
}

interface TableOfContentsProps {
  items: TocItem[];
  title: string;
}

export function TableOfContents({ items, title }: TableOfContentsProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (items.length < 2) return null;

  return (
    <nav className={styles.toc} aria-label={title}>
      <button 
        className={styles.toggle}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className={styles.toggleTitle}>{title}</span>
        <svg 
          className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {isOpen && (
        <ol className={styles.list}>
          {items.map((item) => (
            <li key={item.id} className={styles.item}>
              <a href={`#${item.id}`} className={styles.link}>
                {item.heading}
              </a>
            </li>
          ))}
        </ol>
      )}
    </nav>
  );
}
